import createIcon from '../../createIcon';

/**
 * @component @name BabyChangingStation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgOC41VjEwLjVIMTFMOC4zMSA5LjMyTDcgMTMuMjVWMjIuNUgzVjEyLjVMNC41OCA3Ljg3QzQuOTYgNi43NSA2LjIyIDYuMTkgNy4zIDYuNjhMMTEuNDUgOC41MUwxNCA4LjVaTTggMS41QzYuOSAxLjUgNiAyLjQgNiAzLjVDNiA0LjYgNi45IDUuNSA4IDUuNUM5LjEgNS41IDEwIDQuNiAxMCAzLjVDMTAgMi40IDkuMSAxLjUgOCAxLjVaTTkgMTkuNUgyMVYxNy41SDlWMTkuNVpNMTkuNSAxNi41QzIwLjMzIDE2LjUgMjEgMTUuODMgMjEgMTVDMjEgMTQuMTcgMjAuMzMgMTMuNSAxOS41IDEzLjVDMTguNjcgMTMuNSAxOCAxNC4xNyAxOCAxNUMxOCAxNS44MyAxOC42NyAxNi41IDE5LjUgMTYuNVpNMTMgMTIuNUMxMyAxMS45NSAxMi41NSAxMS41IDEyIDExLjVIOVYxMy41SDExVjE0LjVDMTEgMTUuNiAxMS45IDE2LjUgMTMgMTYuNUgxNUMxNi4xIDE2LjUgMTcgMTUuNiAxNyAxNC41VjExLjVIMTVWMTMuNUgxM1YxMi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BabyChangingStation = createIcon('BabyChangingStation', [
  [
    'path',
    {
      d: 'M14 8.5V10.5H11L8.31 9.32L7 13.25V22.5H3V12.5L4.58 7.87C4.96 6.75 6.22 6.19 7.3 6.68L11.45 8.51L14 8.5ZM8 1.5C6.9 1.5 6 2.4 6 3.5C6 4.6 6.9 5.5 8 5.5C9.1 5.5 10 4.6 10 3.5C10 2.4 9.1 1.5 8 1.5ZM9 19.5H21V17.5H9V19.5ZM19.5 16.5C20.33 16.5 21 15.83 21 15C21 14.17 20.33 13.5 19.5 13.5C18.67 13.5 18 14.17 18 15C18 15.83 18.67 16.5 19.5 16.5ZM13 12.5C13 11.95 12.55 11.5 12 11.5H9V13.5H11V14.5C11 15.6 11.9 16.5 13 16.5H15C16.1 16.5 17 15.6 17 14.5V11.5H15V13.5H13V12.5Z',
      key: 'l8brom',
    },
  ],
]);

export default BabyChangingStation;
